export enum ReasonEnum {
  TROCA_DE_PONTO = 1,
  REPASSE = 2,
  BAIXA_PERFORMANCE = 3,
  OUTROS = 4,
  EM_IMPLANTACAO = 5,
  EM_REFORMA = 6,
  PARADA = 7,
  TROCA_DE_CNPJ = 8,
  EVENTOS = 9,
  CANCELADA = 10,
}
